var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('symbol',{attrs:{"id":(_vm.prefix + "warn"),"viewBox":"0 0 16 16"}},[_c('circle',{staticClass:"base",attrs:{"cx":"8","cy":"8","r":"8"}}),_c('circle',{staticClass:"sign",attrs:{"r":"3","transform":"matrix(1 0 0 -1 8 8)"}})])}
var staticRenderFns = []

export { render, staticRenderFns }